/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Customer card record
 */
export interface CardRecordApiModel {
  /**
   * Card code
   */
  code?: string;
  /**
   * Card id
   */
  id?: string;
  /**
   * Url of loyalty photo
   */
  photo?: string;
  /**
   * Card scope
   */
  scope?: CardRecordApiModelScopeEnum;
  /**
   * Card title, depends of scope (Loyalty name or Platform name)
   */
  title?: string;
}
export enum CardRecordApiModelScopeEnum {
  All = 'all',
  Business = 'business',
  Loyalty = 'loyalty'
}
